import Axios from 'axios';

export default {
  getInstallmentDebts(billingId) {
    return Axios.get('/admin/parcelamento/debts', { params: { billing_id: billingId } }).then(({ data }) => data);
  },
  getStudents(params) {
    return Axios.get('/admin/parcelamento/students', { params }).then(({ data }) => data);
  },
  getStudent(id) {
    return Axios.get(`/admin/parcelamento/students/${id}`).then(({ data }) => data);
  },
  getDocuments(paymentPlanId) {
    return Axios.get(`/admin/parcelamento/payment-plans/${paymentPlanId}/documents`).then(({ data }) => data);
  },
  getDocumentReprovationReason() {
    return Axios.get('/admin/parcelamento/enums/document-reprovation-reason').then(({ data }) => data);
  },
  updateDocuments(paymentPlanId, documents, selectedQpCourse) {
    return Axios.put(`/admin/parcelamento/payment-plans/${paymentPlanId}/documents`, {
      documents,
      selected_qp_course: selectedQpCourse,
    });
  },
  deletePaymentPlanDocument(paymentPlanId, documentId) {
    return Axios.delete(`/admin/parcelamento/payment-plans/${paymentPlanId}/documents/${documentId}`);
  },
  addPaymentPlanDocument(paymentPlanId, document) {
    return Axios.post(`/admin/parcelamento/payment-plans/${paymentPlanId}/documents`, document);
  },
  getQueroPagoCourses(qpStudentId) {
    return Axios.get(`/admin/parcelamento/students/${qpStudentId}/quero-pago-courses`).then(({ data }) => data);
  },
  activateStudent(studentId) {
    return Axios.put(`/admin/parcelamento/students/${studentId}/activate`);
  },
  deactivateStudent(studentId) {
    return Axios.put(`/admin/parcelamento/students/${studentId}/deactivate`);
  },
  confirmDigitalContract(paymentPlan) {
    return Axios.post('/admin/parcelamento/digital_contracts/solicitation_confirmed',
      { payment_plan_id: paymentPlan.id });
  },
  getGenders() {
    return Axios.get('/admin/parcelamento/enums/gender').then(({ data }) => data);
  },
  getMaritalStatus() {
    return Axios.get('/admin/parcelamento/enums/marital-status').then(({ data }) => data);
  },
  updatePersonalData(id, rawValues) {
    return Axios.put(`/admin/parcelamento/personal-data/${id}`, rawValues).then(({ data }) => data);
  },
  getDigitalContractData(paymentPlan) {
    return Axios.get('/admin/parcelamento/digital-contracts/data',
      { params: { payment_plan_id: paymentPlan.id, billing_id: paymentPlan.qpBillingId } }).then(({ data }) => data);
  },
};
